/* ============
 * Material Type Transformer
 * ============
 *
 * The transformer for the materialType.
 */

import Transformer from './transformer';

export default class PackagingMaterialTransformer extends Transformer {

  static fetch(packagingMaterial) {
    return {
      id: packagingMaterial.id,
      name: packagingMaterial.name,
      environmentExciseCodeId: packagingMaterial.environment_excise_code_id,
      baseExciseCodeId: packagingMaterial.base_excise_code_id,
    };
  }

  static send(packagingMaterial) {
    return {
      id: packagingMaterial.id,
      name: packagingMaterial.name,
      environment_excise_code_id: packagingMaterial.environmentExciseCodeId,
      base_excise_code_id: packagingMaterial.baseExciseCodeId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/packagingMaterial.js